import type { TFunction } from "i18next";
import type { CareersNotificationData } from "../../pages/Careers/careersNotification";

/**
 * A Careers notification's two lines in the bell, translated: who did what on which candidate, then what it says —
 * a mention's excerpt, or what a reminder asks for.
 */
export const careersNotificationLine = (data: CareersNotificationData, t: TFunction): { title: string; body: string } => {
	const names = { author: data.author_name, candidate: data.candidate_name, job: data.job_title };
	switch (data.kind) {
		case "note_mention":
		case "feedback_mention":
			return { title: t("careers.notification.mention_title", names), body: data.excerpt };
		case "feedback_reminder":
			return {
				title: t("careers.notification.reminder_title", names),
				body: data.step_name === null ? t("careers.notification.reminder_body") : t("careers.notification.reminder_body_step", { step: data.step_name }),
			};
	}
};
